import React, { useState, useEffect } from "react";
import ProgressBar from "react-bootstrap/ProgressBar";
import "bootstrap/dist/css/bootstrap.min.css";
import "./App.css"; // for custom styling

const App = () => {
  const endTime = new Date("2025-06-06T22:00:00"); // June 6, 2025, 10:00 PM
  const startTime = new Date("2025-06-03T13:00:00");
  const totalDuration = endTime - startTime;

  const [progress, setProgress] = useState(0);
  const [remainingTime, setRemainingTime] = useState({});

  useEffect(() => {
    const timer = setInterval(() => {
      const now = new Date();
      const elapsedTime = now - startTime;
      const percentage = Math.min(100, (elapsedTime / totalDuration) * 100);
      const timeLeft = endTime - now;

      setProgress(percentage);
      setRemainingTime({
        days: Math.floor(timeLeft / (1000 * 60 * 60 * 24)),
        hours: Math.floor((timeLeft / (1000 * 60 * 60)) % 24),
        minutes: Math.floor((timeLeft / (1000 * 60)) % 60),
        seconds: Math.floor((timeLeft / 1000) % 60),
      });

      if (percentage >= 100) clearInterval(timer);
    }, 1000);

    return () => clearInterval(timer);
  }, [totalDuration]);

  return (
    <div className="win-container">
      <div className="win-header">
        <div className="win-title">IP Transfer Utility</div>
        <div className="win-subtitle">
          Transferring from <b>192.168.0.101</b> to <b>172.16.0.205</b>
        </div>
      </div>

      <div className="win-timer">
        <span>{remainingTime.days}d</span>
        <span>{remainingTime.hours}h</span>
        <span>{remainingTime.minutes}m</span>
        <span>{remainingTime.seconds}s</span>
      </div>

      <div className="win-progress">
        <ProgressBar now={progress} striped variant="success" />
        <div className="win-progress-label">
          {Math.floor(progress)}% completed
        </div>
      </div>
    </div>
  );
};

export default App;
